const NAME = "DIGITAL_FOLDER_ANALYSIS_PAGE";

export default NAME;
